<div class="encolumnat">
    <h1 class="titol">{{ 'SHARED.REGISTER.FINAL.COMPONENT.TITLE' | translate }}</h1>
    <h2 class="texte">{{ 'SHARED.REGISTER.FINAL.COMPONENT.SUBTITLE' | translate }}</h2>

    <div class="button-zone">
        <button mat-flat-button color="primary" class="action seguent sol"
            (click)="next()" [disabled]="pendigResponse">{{'REGISTERCOMPONENT.FINISHBUTTON.LABEL' | translate}}</button>
    </div>
</div>